import { PreTransaction } from "@/app/services/authorizationService/getAuthorization";
import { BasicTable } from "@/view/components/BasicTable";
import { Input } from "@/view/components/ui/input";
import { Search } from "lucide-react";
import { AuthorizationSheet } from "./components/AuthorizationSheet";
import { useAuthorizationTableController } from "./useAuthorizationTableController";
import { ModalSimulatePan } from "../TransactionTable/components/TransactionDetails/components/SimulatePanModal";

export const AuthorizationTable = () => {
  const {
    table,
    isLoading,
    isFetching,
    handleRowClick,
    selectedItem,
    sheetOpen,
    setSheetOpen,
    observerRef,
    isFetchingNextPage,
    shouldShowInfiniteScroll,
    handleSimulate,
    simulatePanOpen,
    setSimulatePanOpen,
    search,
    handleSearchInputChange,
  } = useAuthorizationTableController();

  return (
    <>
      <div className="mb-4 flex items-center gap-2">
        <div className="relative flex items-center">
          <Search size={20} className="z-2 absolute left-4 top-3" />
          <Input
            className="ml-1 w-48 rounded-3xl pl-10 sm:w-64 md:w-80 lg:w-96"
            placeholder="Pesquisar"
            value={search}
            onChange={handleSearchInputChange}
          />
        </div>
      </div>

      <BasicTable<PreTransaction>
        table={table}
        type="only header"
        isLoading={isLoading || isFetching}
        handleRowClick={handleRowClick}
        isFetchingNextPage={isFetchingNextPage}
        observerRef={observerRef}
        shouldShowInfiniteScroll={shouldShowInfiniteScroll}
      />

      <div ref={observerRef} />

      <AuthorizationSheet
        open={sheetOpen}
        setOpen={setSheetOpen}
        selectedItem={selectedItem}
        onSimulate={handleSimulate}
      />

      <ModalSimulatePan
        open={simulatePanOpen}
        onOpenChange={setSimulatePanOpen}
        preTransactionId={selectedItem?._id ?? ''}
        customerId={selectedItem?.customerId?._id ?? ''}
      />
    </>
  );
};
